import { Injectable, NgZone, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  private _isOpen = signal(false);
  private _message = signal('');
  private _duration = signal(7000);
  private _position = signal<'top' | 'bottom'>('bottom');
  isOpen = computed(() => this._isOpen());
  message = computed(() => this._message());
  dismissMills = computed(() => this._duration());
  position = computed(() => this._position());

  private _timer: any = null;

  constructor(private zone: NgZone) {}

  /**
   * Show snackbar with dynamic message and position
   * @param message Text to display
   * @param duration How long to show (ms)
   * @param position 'top' | 'bottom' (default: 'bottom')
   */
  show(message: string, duration = 7000, position: 'top' | 'bottom' = 'bottom') {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
    this._message.set(message ?? '');
    this._duration.set(duration ?? 7000);
    this._position.set(position ?? 'bottom');
    this._isOpen.set(true);
    if (duration > 0) {
      this.zone.runOutsideAngular(() => {
        this._timer = setTimeout(() => {
          this.zone.run(() => this.dismiss());
        }, duration);
      });
    }
  }

  dismiss() {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
    this._isOpen.set(false);
  }
}